import { apiFetch } from "@/lib/api-client";
import { team } from "@duress/shared";

export async function listTeamRoster(clientId: string): Promise<team.TeamRosterListResponse> {
  return apiFetch(`/clients/${clientId}/teams`, team.TeamRosterListResponseSchema);
}

export async function setTeamRosterExcluded(
  clientId: string,
  teamId: string,
  excluded: boolean,
): Promise<team.TeamRosterEntry> {
  return apiFetch(
    `/clients/${encodeURIComponent(clientId)}/teams/${encodeURIComponent(teamId)}`,
    team.TeamRosterEntrySchema,
    {
      method: "PATCH",
      body: JSON.stringify({ excluded } satisfies team.UpdateTeamRosterEntryRequest),
    },
  );
}
